import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import profile from './modules/profile'
import modal from './modules/modal'
import coursesList from './modules/coursesList'
import teachers from './modules/teachers'
import msg from './modules/msg'
import faq from './modules/faq'
import terms_service from './modules/terms_service'
import contacts from './modules/contacts'
import recommendations from './modules/recommendations'
import user from './modules/user'
import handbook from './modules/handbook'
import calendar from './modules/calendar'
import calendar_small from './modules/calendar_small'
import locale from './modules/locale'
import notice from './modules/notice'
import dialog from './modules/dialog'
import staticText from './modules/staticText'
import articles from './modules/articles'
import meta from './modules/meta'
import standartObjects from './modules/standartObjects'

import {
    SOCKET_ONOPEN,
    SOCKET_ONCLOSE,
    SOCKET_ONERROR,
    SOCKET_ONMESSAGE,
    SOCKET_RECONNECT,
    SOCKET_RECONNECT_ERROR
} from './mutation-types'

export const store = new Vuex.Store({
	state: {
        socket: {
            isConnected: false,
            message: '',
            reconnectError: false,
        },
        newNotice: 0,
        newMsg: [],
        mobileState: false,
        mobileCalendar: false,
        load: false,
        preload: false,
        menuState: false,
        menuState_profile: false,
        callbackAbsolute: false,
        filterState: false,
        sortState: false,
	},
	getters: {
        mobileState(state){
            return state.mobileState
        },
        mobileCalendar(state){
            return state.mobileCalendar
        },
        load(state){
            return state.load
        },
        preload(state){
            return state.preload;
        },
        menuState(state){
            return state.menuState
        },
        menuState_profile(state){
            return state.menuState_profile
        },
        callbackAbsolute(state){
            return state.callbackAbsolute
        },
        filterState(state){
            return state.filterState
        },
        sortState(state){
            return state.sortState
        },
        newNotice(state){
            return state.newNotice;
        },
        newMsg(state){
            return state.newMsg;
        }
	},
	mutations: {
        [SOCKET_ONOPEN](state, event)  {
            state.socket.isConnected = true
        },
        [SOCKET_ONCLOSE](state, event)  {
            state.socket.isConnected = false
        },
        [SOCKET_ONERROR](state, event)  {
            console.error(state, event)
        },
        [SOCKET_ONMESSAGE](state, message)  {
            state.socket.message = message;

            for(let key in message){
                switch (key){
                    case 'dialog':
                        state.newMsg.push(parseInt(message.dialogId));
                        break;
                    case 'notice':
                        state.newNotice++;
                        break;
                    default:
                        break;
                }
            }
        },
        [SOCKET_RECONNECT](state, count) {
            console.info(state, count)
        },
        [SOCKET_RECONNECT_ERROR](state) {
            state.socket.reconnectError = true;
        },
        UpdateNotice(state, data){
            state.newNotice = data
        },
        UpdateMsg(state, data){
            state.newMsg = data.map((item) => {
                return parseInt(item)
            })
        },
        SpliceMsg(state, data){
            state.newMsg.splice(data, 1);
        },
        OpenDialogMsg(state, id){
            // state.newMsg.splice(data, 1);
            
            let newArray = state.newMsg.filter( (item)=>{ return item != id; } );
            state.newMsg = newArray;
        },
        ClearNotice(state){
            state.newNotice = 0;
        },
        ClearMsg(state){
            state.newMsg = [];
        },
        updateMobileState(state, data){
            state.mobileState = data
        },
        updateMobileCalendar(state, data){
            state.mobileCalendar = data
        },
        Loading(state){
            state.load = true
        },
        UpdatePreloadState(state, data){
            state.preload = data;
        },
        menuOpen(state){
            state.menuState_profile = false;
            state.menuState = true
        },
        menuOpen_profile(state){
            state.menuState = false;
            state.menuState_profile = true
        },
        menuClose(state){
            state.menuState = false;
            state.menuState_profile = false
        },
        callbackSetAbsolute(state){
            state.callbackAbsolute = true
        },
        callbackSetNoAbsolute(state){
            state.callbackAbsolute = false
        },
        filterOpen(state){
            state.filterState = true
        },
        filterClose(state){
            state.filterState = false
        },
        sortOpen(state){
            state.sortState = true
        },
        sortClose(state){
            state.sortState = false
        },
	},
	actions: {
        UpdateNotice(context, data){
            context.commit('UpdateNotice', data)
        },
        UpdateMsg(context, data){
            context.commit('UpdateMsg', data)
        },
        ClearNotice(context){
            context.commit('ClearNotice')
        },
        ClearMsg(context){
            context.commit('ClearMsg')
        },
        updateMobileState(context, data){
            context.commit('updateMobileState', data)
        },
        updateMobileCalendar(context, data){
            context.commit('updateMobileCalendar', data)
        },
        UpdatePreloadState(context, data){
            context.commit('UpdatePreloadState', data)
        },
        Loading(context){
            context.commit('Loading')
        },
        menuOpen(context){
            context.commit('menuOpen')
        },
        menuOpen_profile(context){
            context.commit('menuOpen_profile')
        },
        menuClose(context){
            context.commit('menuClose')
        },
        callbackSetAbsolute(context){
            context.commit('callbackSetAbsolute')
        },
        callbackSetNoAbsolute(context){
            context.commit('callbackSetNoAbsolute')
        },
        filterOpen(context){
            context.commit('filterOpen')
        },
        filterClose(context){
            context.commit('filterClose')
        },
        sortOpen(context){
            context.commit('sortOpen')
        },
        sortClose(context){
            context.commit('sortClose')
        },
	},
    modules: {
        profile,
        modal,
        coursesList,
        teachers,
        msg,
        faq,
        terms_service,
        contacts,
        recommendations,
        user,
        handbook,
        calendar,
        calendar_small,
        locale,
        notice,
        dialog,
        staticText,
        articles,
        meta,
        standartObjects
    },
	strict: process.env.NODE_ENV !== 'production'
});


// WEBPACK FOOTER //
// ./src/store/index.js